import { useQuery } from "@tanstack/react-query";

import { fetchMdsMappings } from "clients/mdsClient";
import { MDS_RESOURCE_TYPES } from "constants/coupons";
import {
  COUNTRY_MAPPINGS_STALE_TIME,
  QUERY_RETRY_ATTEMPTS,
} from "constants/queryCacheTimes";
import { normalizeCountryMappings } from "helpers/countryMappings";

export const countryQueryKeys = {
  all: ["mds", "country"],
};

export const useCountriesMappings = () =>
  useQuery({
    queryKey: countryQueryKeys.all,
    queryFn: async () => {
      const items = await fetchMdsMappings(MDS_RESOURCE_TYPES.COUNTRY);
      return normalizeCountryMappings(items);
    },
    staleTime: COUNTRY_MAPPINGS_STALE_TIME,
    retry: QUERY_RETRY_ATTEMPTS,
    refetchOnMount: true,
  });
